<template>
  <section>
    <nav-component :titulo="'Clientes'" :link="can('clientes.registrar') ? { path: '/agregar-cliente' } : null" :texto="'Agregar cliente'" />

    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Clientes</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <b-select v-model="porPagina" @input="cambiarPorPagina" size="is-small">
          <option :value="10">10 / pág</option>
          <option :value="20">20 / pág</option>
          <option :value="50">50 / pág</option>
        </b-select>
        <span class="has-text-muted" style="font-size:0.78rem;color:var(--color-text-dim)">
          {{ total }} clientes
        </span>
      </div>
      <div class="table-toolbar-right">
        <b-button type="is-primary" size="is-small" icon-left="printer" tag="a" href="#/pdf/clientes" target="_blank" rel="noopener noreferrer">
          Imprimir
        </b-button>
      </div>
    </div>

    <b-table
      class="box"
      :data="clientes"
      :paginated="true"
      :per-page="porPagina"
      :current-page="pagina"
      :total="total"
      :backend-pagination="true"
      :pagination-rounded="true"
      :pagination-simple="false"
      pagination-position="bottom"
      default-sort-direction="asc"
      @page-change="onCambioPagina"
    >
      <b-table-column field="nombre"    label="Nombre"    sortable v-slot="props">{{ props.row.nombre }}</b-table-column>
      <b-table-column field="ci"        label="Cédula/RIF" sortable v-slot="props">{{ props.row.ci }}</b-table-column>
      <b-table-column field="tipo"      label="Tipo"      sortable v-slot="props">{{ props.row.tipo }}</b-table-column>
      <b-table-column field="telefono"  label="Teléfono"  sortable v-slot="props">{{ props.row.telefono }}</b-table-column>
      <b-table-column field="direccion" label="Dirección" sortable v-slot="props">{{ props.row.direccion }}</b-table-column>

      <b-table-column label="Acciones" v-slot="props">
        <div class="is-flex" style="gap:4px">
          <b-button v-if="can('clientes.editar')" type="is-info" size="is-small" icon-left="pen" @click="editar(props.row.id)" />
          <b-button v-if="can('clientes.eliminar')" type="is-danger" size="is-small" icon-left="delete" @click="eliminar(props.row.id)" />
        </div>
      </b-table-column>
    </b-table>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'

export default {
  name: "ClientesComponent",
  components: { NavComponent },

  data: () => ({
    cargando: false,
    clientes: [],
    pagina: 1,
    porPagina: 20,
    total: 0,
  }),

  mounted() {
    this.obtenerClientes()
  },

  methods: {
    onCambioPagina(p) {
      this.pagina = p
      this.obtenerClientes()
    },

    cambiarPorPagina() {
      this.pagina = 1
      this.obtenerClientes()
    },

    async eliminar(id) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar cliente',
        message: '¿Seguro que quieres <b>eliminar</b> este cliente? Esta acción no se puede revertir.',
        confirmText: 'Sí, eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.cargando = true
          HttpService.eliminar('clientes.php', { accion: 'eliminar', id })
            .then(ok => {
              this.cargando = false
              if (ok) {
                this.$buefy.toast.open({ type: 'is-success', message: 'Cliente eliminado.' })
                this.obtenerClientes()
              } else {
                this.$buefy.toast.open('Error al eliminar')
              }
            })
        }
      })
    },

    editar(id) {
      this.$router.push({ name: "EditarCliente", params: { id } })
    },

    obtenerClientes() {
      this.cargando = true
      HttpService.obtenerConConsultas("clientes.php", {
        accion: "obtener",
        pagina: this.pagina,
        porPagina: this.porPagina,
      }).then(resp => {
        // Soporte para respuesta paginada { clientes, total } o arreglo directo
        if (Array.isArray(resp)) {
          this.clientes = resp
          this.total = resp.length
        } else {
          this.clientes = resp.clientes || resp.data || []
          this.total = resp.total || this.clientes.length
        }
        this.cargando = false
      })
    }
  }
}
</script>
